export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
export const ACCOUNT_INITIALIZE = "ACCOUNT_INITIALIZE";
export const REFRESH_TOKEN = "REFRESH_TOKEN";
export const INITIALIZE_CHANNELS = "INITIALIZE_CHANNELS";
export const CHANGE_CHANNEL = "CHANGE_CHANNEL";
export const CHANGE_ISSUER = "CHANGE_ISSUER";

export const LOCAL_STORE_TOKEN_NAME = "accessToken";

export const login = (account) => {
  return {
    type: LOGIN,
    payload: account,
  };
};
export const refreshToken = (account) => {
  return {
    type: REFRESH_TOKEN,
    payload: account,
  };
};
export const logout = () => {
  return {
    type: LOGOUT,
  };
};
export const authInitialize = (account) => {
  return {
    type: ACCOUNT_INITIALIZE,
    payload: account,
  };
};
export const initializeChannels = (data) => {
  return {
    type: INITIALIZE_CHANNELS,
    payload: data,
  };
};
export const changeChannel = (data) => {
  return {
    type: CHANGE_CHANNEL,
    payload: data,
  };
};
export const changeIssuer = (data) => {
  return {
    type: CHANGE_ISSUER,
    payload: data,
  };
};
export const accountInitialize = (account) => {
  return {
    type: ACCOUNT_INITIALIZE,
    payload: account,
  };
};
